
import React, {FC} from 'react';
import {useLocation} from '@reach/router';
import FacebookIcon from 'assets/icons/socials-share/Facebook.svg';
import InstagramIcon from 'assets/icons/socials-share/Instagram.svg';
import TwitterIcon from 'assets/icons/socials-share/Twitter.svg';
import WhatsAppIcon from 'assets/icons/socials-share/Whatsapp.svg';

import SocialIcon from './SocialIcon';

import * as styles from './styles.module.scss';

export const Socials: FC = () => {
	const {href} = useLocation();
	return (
		<div className={styles.socialWrapper}>
			<div className={styles.iconsContainer}>
				<SocialIcon Icon={<WhatsAppIcon />} link={`https://wa.me/?text=${href}`} />
				<SocialIcon Icon={<TwitterIcon />} link={`https://twitter.com/intent/tweet?text=${href}`} />
				<SocialIcon Icon={<InstagramIcon />} link={`https://www.instagram.com/?url=${href}`} />
				<SocialIcon Icon={<FacebookIcon />} link={`https://www.facebook.com/share.php?u=${href}`} />
			</div>
		</div>
	);
};
